<template>
  <div>
    <DashboardHeader />
    <PayrollFormEdit />
    <DashboardFooter />
  </div>
</template>

<script>
  import DashboardHeader from '../components/DashboardHeader'
  import PayrollFormEdit from '../components/PayrollFormEdit'
  import DashboardFooter from '../components/DashboardFooter'

  export default {
    name: 'PayrollViewEdit',

    components: {
      DashboardHeader,
      PayrollFormEdit,
      DashboardFooter
    },
  }
</script>
